// config.js
// This embeds non-sensitive variables into the client-side javascript configuration. 
const config = {
    COGNET_DB_API_URL: "https://dbapiebs.cog-net.com",
    REACT_APP_BUCKET: "autonocogs3"
  };
  
  export default config;
